import app from '@/app';
import templateUrl from './pavementPerformance-search.html';

/* @ngInject */
function PavementPerformanceSearchController($controller, $state, DialogService, PavementPerformance, Principal, $http, AlertService) {
	var $ctrl = this;
	var resource = PavementPerformance;
	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	var transition = $ctrl.transition;

	$ctrl.transition = params => {
		transition(params);
		$ctrl.road = $ctrl.allRoads.content.find(it => it.id == params.road);
		$ctrl.campaigns = _.flow(
			_.keyBy('id'),
			_.at(params.campaigns || [])
		)($ctrl.allCampaigns.content);
		$http.get('api/projects', { params: { onlyUsed: true } }).then(function(response) {
			$ctrl.allProjects = response.data.content;
		});
		resource.query(
			{
				plantype: 'PAVEMENTPERFORMANCE',
				road: params.road,
				campaign: params.campaign,
				sort: params.sort,
				page: params.page,
				size: params.size,
				project: params.project,
				situationPlan: params.situationPavement
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

	$ctrl.onQueryChange = () => {
		var pCampaign = $ctrl.campaign && $ctrl.campaign.id ? $ctrl.campaign.id : null;
		var pRoad = $ctrl.road && $ctrl.road.id ? $ctrl.road.id : null;
		var pOrganization = $ctrl.organization && $ctrl.organization.id ? $ctrl.organization.id : null;
		var pProject = $ctrl.project && $ctrl.project.id ? $ctrl.project.id : null;
		var pSituationPavement = $ctrl.situationPavement;

		resource.query(
			{
				plantype: 'PAVEMENTPERFORMANCE',
				organization: pOrganization,
				road: pRoad,
				roadtype: $ctrl.roadtype,
				campaign: pCampaign,
				sort: $ctrl.sort,
				page: 0,
				size: $ctrl.size,
				project: pProject,
				situationPlan: pSituationPavement
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	$ctrl.clearUiSelect = function($event, $select, field) {
		$event.stopPropagation();
		$select.selected = null;
		$select.search = null;
		field = null;
	};

	$ctrl.remove = id => {
		var entity = $ctrl.entities.find(e => e.id === id);
		resource.remove({ id: id }, () => {
			AlertService.success('entity.delete.message', {
				type: 'pavementPerformance',
				name: entity ? entity.name : ''
			});
			$state.reload();
		});
	};
}

app.component('pavementPerformanceSearch', {
	templateUrl,
	controller: PavementPerformanceSearchController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<',
		allDecisionTrees: '<',
		allCostTables: '<',
		allCriteriaSets: '<'
	}
});
